<template>
  <div class="main">
    <Header
      :show="true"
      title="库存查询"
      left="prepage"
      :click-left="handleClickLeft"
    />
    <div class="content">
      <van-cell-group>
        <van-cell
          :value="rangeQueryDate"
          is-link
          title="时间区间"
          @click="listQuery.showCalendar = true"
        />
        <van-calendar
          v-model="listQuery.showCalendar"
          type="range"
          :max-range="366"
          :min-date="new Date(2020, 1, 1)"
          :max-date="new Date(2030, 12, 31)"
          :default-date="listQuery.data.date"
          @confirm="onDateQueryChoose"
        />
      </van-cell-group>
      <div style="padding: 16px">
        <van-button
          round
          block
          type="info"
          :loading="table.loading"
          @click="handleQuery"
        >
          查询
        </van-button>
      </div>
      <el-table
        ref="table"
        :loading="table.loading"
        :data="table.data"
        style="width: 100%"
        @row-click="onTableRowClick"
      >
        <el-table-column
          type="expand"
          width="30px"
          align="center"
        >
          <template slot-scope="{ row }">
            <el-form
              label-position="left"
              label-width="100px"
              class="table-expand-form"
            >
              <el-form-item label="起始库存">
                <span>{{ row.initStock }} {{ row.materialName === '柴油' ? 'L' : '吨' }}</span>
              </el-form-item>
              <el-form-item label="期间入库">
                <span>{{ row.spikeStock }} {{ row.materialName === '柴油' ? 'L' : '吨' }}</span>
              </el-form-item>
              <el-form-item label="期间消耗">
                <span>{{ row.lossStock }} {{ row.materialName === '柴油' ? 'L' : '吨' }}</span>
              </el-form-item>
              <el-form-item label="期间盘点">
                <span>{{ row.offsetStock }} {{ row.materialName === '柴油' ? 'L' : '吨' }}</span>
              </el-form-item>
              <el-form-item label="期末库存">
                <span>{{ row.lastStock }} {{ row.materialName === '柴油' ? 'L' : '吨' }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column
          label="序号"
          type="index"
          align="center"
          width="60"
        />
        <el-table-column
          label="料仓"
          props="portName"
          align="center"
          width="100"
        >
          <template slot-scope="{ row }">
            {{ row.portName }}
          </template>
        </el-table-column>
        <el-table-column
          label="物料名称"
          props="materialName"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            {{ row.materialName }}
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-pagination
        v-show="table.total > 0"
        :total="table.total"
        background
        layout="prev, pager, next"
        :current-page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        style="margin: 0.6rem 0; text-align: center"
        @current-change="handleQuery"
      /> -->
    </div>
    <Footer value="service" />
  </div>
</template>
<script>
import { showPhoneAlarm } from "@/global/function.js";
import checkPermission from "@/utils/permission";

import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";

import { getStock as getList } from "@/api/port";
import { returnConcrete } from "@/api/return-concrete";

import dayjs from "dayjs";

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      listQuery: {
        limit: 10,
        page: 1,
        showCalendar: false,
        data: {
          date: [
            dayjs().startOf("month").toDate(),
            dayjs().endOf("month").toDate(),
          ],
        },
      },
      returnConcreteId: "",
      showReturnConcrete: false,
      table: {
        loading: false,
        key: "table",
        total: 0,
        data: [],
      },
    };
  },
  computed: {
    rangeQueryDate() {
      const { date } = this.listQuery.data;
      return `${dayjs(date[0]).format("YYYY-MM-DD")} - ${dayjs(date[1]).format(
        "YYYY-MM-DD"
      )}`;
    },
  },
  created() {
    this.handleQuery();
  },
  methods: {
    checkPermission,
    handleClickLeft() {
      this.$router.go(-1);
    },
    handleQuery() {
      const { limit, page, data } = this.listQuery;
      const payload = { ...data, limit, page };
      this.table.loading = true;
      getList(payload)
        .then(({ data }) => {
          this.table.data = data.data;
          this.table.total = data.data.length;
        })
        .finally(() => {
          this.table.loading = false;
        });
    },
    onDateQueryChoose(val) {
      this.listQuery.data.date = val;
      this.listQuery.showCalendar = false;
      this.handleQuery();
    },
    onStatusQueryChoose(val) {
      this.listQuery.data.detectStatus = val.value;
      this.listQuery.showStatusActionSheet = false;
    },
    onTableRowClick(row) {
      this.$refs.table.toggleRowExpansion(row);
    },
    handleClickUpdate(row) {
      this.$router.push({
        path: "/service/business/owdr/create",
        query: row,
      });
    },
    async handleReturnConcrete(row) {
      await this.$dialog.confirm({
        title: "退砼",
        message: "是否确认执行退砼操作？",
      });
      const { data } = await returnConcrete(row.id);
      if (
        showPhoneAlarm(true, "toast", null, 2000, data.code, "退砼", data.msg)
      ) {
        this.handleQuery();
      }
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep .van-cell__title {
  max-width: 30%;
  font-size: 2vh;
}
::v-deep .van-cell__value {
  max-width: 70%;
}
.content {
  padding-bottom: 80px;
}
.table-expand-form {
  padding: 0 12px;

  .el-form-item {
    margin: 4px 0px;
  }
}
</style>
